module.exports = __webpack_public_path__ + "img/collection-weddingRingsRedgold.33f572e.jpg";